import i18n from '../i18n';
import { TEXT_LABELS } from 'playable/dist/src';

export default () => ({
  [TEXT_LABELS.LOGO_LABEL]: i18n.t('player.watch-on-site-label'),
  [TEXT_LABELS.LOGO_TOOLTIP]: i18n.t('player.watch-on-site-tooltip'),
  [TEXT_LABELS.PAUSE_CONTROL_LABEL]: i18n.t('player.pause-control-label'),
  [TEXT_LABELS.PLAY_CONTROL_LABEL]: i18n.t('player.play-control-label'),
  [TEXT_LABELS.PROGRESS_CONTROL_LABEL]: i18n.t('player.progress-control-label'),
  [TEXT_LABELS.PROGRESS_CONTROL_VALUE]: ({ percent = 0 }) =>
    i18n.t('player.progress-control-value', { percent }),
  [TEXT_LABELS.MUTE_CONTROL_LABEL]: i18n.t('player.mute-control-label'),
  [TEXT_LABELS.UNMUTE_CONTROL_LABEL]: i18n.t('player.unmute-control-label'),
  [TEXT_LABELS.VOLUME_CONTROL_LABEL]: i18n.t('player.volume-control-label'),
  [TEXT_LABELS.VOLUME_CONTROL_VALUE]: ({ volume = 0 }) =>
    i18n.t('player.volume-control-value', { percent: volume }),
  [TEXT_LABELS.ENTER_FULL_SCREEN_LABEL]: i18n.t(
    'player.enter-full-screen-label',
  ),
  [TEXT_LABELS.EXIT_FULL_SCREEN_LABEL]: i18n.t('player.exit-full-screen-label'),
});
